/**
 * Tiny localStorage-backed "recently viewed" list, shown in the command
 * palette before the user types. Detail pages call recordRecent() on load;
 * the palette reads getRecents() each time it opens.
 */
export interface RecentEntry {
  label: string;
  sublabel: string | null;
  href: string;
}

const KEY = 'recently-viewed';
const MAX = 8;

export function recordRecent(entry: RecentEntry): void {
  try {
    const list = getRecents().filter((e) => e.href !== entry.href);
    list.unshift(entry);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    // localStorage full/blocked — recents are a nicety, never an error
  }
}

export function getRecents(): RecentEntry[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (e): e is RecentEntry => e && typeof e.label === 'string' && typeof e.href === 'string',
    );
  } catch {
    return [];
  }
}
